import type { BatchStudentReport, StudentAttendanceRecord } from "../types/attendance";

export interface MappedStudentReportRow {
  id: string;
  slNo: number;
  studentName: string;
  studentId: string;
  usn: string;
  date: string;
  purpose: string;
  attendanceNo: string;
  present: "Y" | "N";
  remark: string;
  recordId?: number;
}

function absentPlaceholder(
  student: BatchStudentReport["students"][number],
  attendanceNo?: string,
): StudentAttendanceRecord {
  return {
    slNo: 1,
    date: "",
    purpose: "",
    attendanceNo: attendanceNo || "",
    present: "N",
    remark: "",
  };
}

export function mapStudentReportRows(
  data: BatchStudentReport,
  attendanceNo?: string,
): MappedStudentReportRow[] {
  let slNo = 1;
  return data.students.flatMap((student) => {
    const matching = student.records.filter(
      (record) => !attendanceNo || record.attendanceNo === attendanceNo,
    );
    const recordsToShow = matching.length > 0 ? matching : [absentPlaceholder(student, attendanceNo)];
    return recordsToShow.map((record) => ({
      id: `${student.studentId}-${record.recordId ?? record.attendanceNo}-${record.slNo}`,
      slNo: slNo++,
      studentName: student.studentName,
      studentId: student.studentId,
      usn: student.usn || "",
      date: record.date,
      purpose: record.purpose,
      attendanceNo: record.attendanceNo,
      present: record.present,
      remark: record.remark,
      recordId: typeof record.recordId === "number" ? record.recordId : undefined,
    }));
  });
}
